import Button from "@mostrans/web-components/components/base/Button";
import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ContentAdditionalInfo from "./components/ContentAdditionalInfo";
import ModalAdditionalInfo from "./components/ModalAdditionalInfo";

const AdditionalInfo = (props) => {
  const { media, data, setData } = props;
  const [openModal, setOpenModal] = useState(false);
  const [values, setValues] = useState({
    curr_salary: data?.curr_salary,
    curr_benefits: data?.curr_benefits || [],
    expected_salary: data?.expected_salary,
    expected_benefits: data?.expected_benefits || [],
  });

  const inputData = [
    {
      name: "curr_salary",
      nama: "Current Salary",
      placeholder: "Input current salary",
      type: "currency",
      textArea: false,
    },
    {
      name: "curr_benefits",
      nama: "Current Benefits",
      placeholder: "Input current benefits",
      type: "text",
      textArea: true,
    },
    {
      name: "expected_salary",
      nama: "Expected Salary",
      placeholder: "Input expected salary",
      type: "currency",
      textArea: false,
    },
    {
      name: "expected_benefits",
      nama: "Expected Benefits",
      placeholder: "Input Expected benefits",
      type: "text",
      textArea: true,
    },
  ];

  const onChangeInput = (name, value) => {
    setValues({ ...values, [name]: value });
  };

  const modalClose = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    setValues({
      curr_salary: data?.curr_salary,
      curr_benefits: data?.curr_benefits || [],
      expected_salary: data?.expected_salary,
      expected_benefits: data?.expected_benefits || [],
    });
  }, [data]);

  return (
    <>
      <Box>
        <Grid container spacing={1} py={2}>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Typography variant="h4" component="h4">
              Additional Info
            </Typography>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: media ? "flex-start" : "flex-end",
              }}>
              <Button
                variant="text"
                color="primary"
                size="small"
                type="tertiary"
                onClick={() => {
                  setOpenModal(true);
                }}
                startIcon={<span className="material-icons"> edit </span>}
                sx={{ fontSize: "14px" }}>
                Edit Additional Info
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box>
        <ContentAdditionalInfo data={data} />
      </Box>
      <ModalAdditionalInfo
        openModal={openModal}
        modalClose={modalClose}
        inputData={inputData}
        values={values}
        setData={setData}
        onChangeInput={onChangeInput}
      />
    </>
  );
};

export default AdditionalInfo;
